import React, {useState} from 'react'
import ReactPaginate from "react-paginate";
import './style.scss'


const Index = ({total=1, currentPage=0, setCurrentPage=() => {}}) => {
    // const [currentPage, setCurrentPage] = useState(0);

    const handlePageChange = (selected) => {
      setCurrentPage(selected.selected);
    };


    return (
        <div>
            <ReactPaginate
                previousLabel={<span><i className='fal fa-angle-left' /></span>}
                nextLabel={<span><i className='fal fa-angle-right' /></span>}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(total)}  // Total number of pages
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={handlePageChange}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                initialPage={currentPage}
                forcePage={currentPage}
            />
        </div>
    )
}

export default Index